var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-switch',{staticClass:"expandbtn mt-0 pt-0",attrs:{"label":"Expand All","hide-details":"","inset":""},on:{"click":function($event){$event.stopPropagation();}},model:{value:(_vm.expandPanels),callback:function ($$v) {_vm.expandPanels=$$v},expression:"expandPanels"}})
}
var staticRenderFns = []

export { render, staticRenderFns }